import React from 'react';
import { motion } from 'framer-motion';
import type { ChapterVisual } from '../types/pulse';
interface VisualOverlayProps {
  variant: ChapterVisual;
  accent: string;
}
const CELLS = [{
  cx: 48,
  cy: 70,
  r: 10
}, {
  cx: 110,
  cy: 40,
  r: 18
}, {
  cx: 170,
  cy: 92,
  r: 7
}, {
  cx: 236,
  cy: 52,
  r: 24
}, {
  cx: 318,
  cy: 88,
  r: 12
}, {
  cx: 352,
  cy: 30,
  r: 6
}, {
  cx: 76,
  cy: 168,
  r: 22
}, {
  cx: 150,
  cy: 196,
  r: 9
}, {
  cx: 214,
  cy: 162,
  r: 14
}, {
  cx: 290,
  cy: 196,
  r: 28
}, {
  cx: 358,
  cy: 160,
  r: 9
}, {
  cx: 24,
  cy: 228,
  r: 6
}];
const FOLLICLES = [{
  cx: 96,
  cy: 110,
  max: 70
}, {
  cx: 270,
  cy: 80,
  max: 54
}, {
  cx: 220,
  cy: 200,
  max: 40
}];
const NODES = [[40, 200], [96, 120], [160, 170], [210, 70], [270, 140], [330, 60], [360, 190]];
export function VisualOverlay({
  variant,
  accent
}: VisualOverlayProps) {
  return <svg aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 390 260" preserveAspectRatio="xMidYMid slice" data-id="element-782" data-mp="3qy2cjeeepsxw">
      {variant === 'variability' && CELLS.map((c, i) => <motion.circle key={i} cx={c.cx} cy={c.cy} fill="none" stroke={accent} strokeWidth={1} initial={{
      r: c.r,
      opacity: 0
    }} animate={{
      r: [c.r, c.r * 1.18, c.r],
      opacity: [0.25, 0.85, 0.25]
    }} transition={{
      duration: 3 + i % 3,
      delay: i * 0.18,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-783" data-mp="pv86w2pqufy7" data-mpi={i} />)}

      {variant === 'follicles' && FOLLICLES.flatMap((f, i) => [0, 1, 2].map(ring => <motion.circle key={`${i}-${ring}`} cx={f.cx} cy={f.cy} fill="none" stroke={accent} strokeWidth={1.2} initial={{
      r: 4,
      opacity: 0
    }} animate={{
      r: [4, f.max],
      opacity: [0.8, 0]
    }} transition={{
      duration: 4.2,
      delay: i * 0.7 + ring * 1.4,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-784" data-mp="ut05ffkw90bd" />))}

      {variant === 'lattice' && <>
          {NODES.slice(0, -1).map((n, i) => {
        const m = NODES[i + 1];
        return <motion.path key={`l-${i}`} d={`M${n[0]} ${n[1]} L${m[0]} ${m[1]}`} stroke={accent} strokeWidth={1} fill="none" initial={{
          pathLength: 0,
          opacity: 0
        }} animate={{
          pathLength: [0, 1],
          opacity: [0, 0.8, 0.8]
        }} transition={{
          duration: 2.4,
          delay: i * 0.35,
          repeat: Infinity,
          repeatType: 'reverse',
          repeatDelay: 1
        }} data-id="element-785" data-mp="1s5eyy2b33v8m" data-mpi={i} />;
      })}
          {NODES.map((n, i) => <motion.circle key={`n-${i}`} cx={n[0]} cy={n[1]} r={3} fill={accent} initial={{
        opacity: 0
      }} animate={{
        opacity: [0.3, 1, 0.3]
      }} transition={{
        duration: 2.6,
        delay: i * 0.3,
        repeat: Infinity
      }} data-id="element-786" data-mp="14fkp7tm2amsl" data-mpi={i} />)}
        </>}
    </svg>;
}